function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import ReactSlider from 'react-slider';
var CheckboxTags = function CheckboxTags(props) {
  var onChange = props.onChange,
    index = props.index;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var _currentQuestion$publ = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.publicParameters,
    step = _currentQuestion$publ.step,
    max = _currentQuestion$publ.max,
    min = _currentQuestion$publ.min,
    defaultValue = _currentQuestion$publ.defaultValue;
  var _useState = useState(parseInt(defaultValue) || null),
    _useState2 = _slicedToArray(_useState, 2),
    stepValue = _useState2[0],
    setStepValue = _useState2[1];
  var handleOnChange = function handleOnChange(value) {
    setStepValue(value);
    onChange(null, value, null, null, index, true);
  };
  var init = function init() {
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var savedResponses = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
    if (savedResponses) {
      Object.keys(savedResponses).forEach(function (key) {
        setStepValue(savedResponses[key]);
      });
    }
  };
  useEffect(function () {
    if (!currentQuestion) {
      return;
    }
    init();
  }, [currentQuestion, responses]);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "8",
    md: "10",
    className: "slider-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "min-number"
  }, " ", min), /*#__PURE__*/React.createElement("span", {
    className: "max-number"
  }, " ", max), /*#__PURE__*/React.createElement(ReactSlider, {
    className: "horizontal-slider",
    thumbClassName: "slider-thumb",
    trackClassName: "slider-track",
    step: parseInt(step) > 1 ? parseInt(step) : 1,
    min: min,
    max: max,
    value: stepValue,
    renderThumb: function renderThumb(props, state) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("span", {
        className: "current-number"
      }, state.valueNow));
    },
    onChange: handleOnChange
  })));
};
CheckboxTags.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
CheckboxTags.defaultProps = {
  elements: [],
  responses: {}
};
export default CheckboxTags;